var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-row"},[_c('img',{staticClass:"footer-img",attrs:{"src":_vm.appLogo,"alt":"logo"}}),_c('div',{staticClass:"footer-name"},[_vm._v(" "+_vm._s(_vm.appName)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }